export enum SpinnerMessageStatusEnum {
    CLOSED = "closed",
    CLOSING = "closing",
    OPENED = "opened",
    OPENING = "opening",
}

export type SpinnerMessageTransitionStatusType =
    | string
    | SpinnerMessageStatusEnum.CLOSED
    | SpinnerMessageStatusEnum.CLOSING
    | SpinnerMessageStatusEnum.OPENED
    | SpinnerMessageStatusEnum.OPENING;
